(() => {
  const config = window.WhimipawOriginal || {};
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function money(cents) {
    const value = (Number(cents || 0) / 100).toFixed(2);
    const format = config.moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(cents || 0) / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function initMenu(scope = document) {
    all('[data-menu-button]', scope).forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const close = () => {
        button.setAttribute('aria-expanded', 'false');
        menu.dataset.open = 'false';
        document.body.classList.remove('menu-open');
      };
      button.addEventListener('click', () => {
        const opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(opening));
        menu.dataset.open = String(opening);
        document.body.classList.toggle('menu-open', opening);
      });
      all('a', menu).forEach((link) => link.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
    });
  }

  function initAccordions(scope = document) {
    all('.accordion-button', scope).forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        panel.dataset.open = String(!open);
      });
    });
  }

  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const productNode = root.querySelector('[data-product-json]');
    if (!productNode) return;
    let product;
    try { product = JSON.parse(productNode.textContent); } catch (error) { return; }

    const gallery = {};
    all('[data-gallery-data] [data-design]', root).forEach((item) => {
      gallery[item.dataset.design] ||= [];
      gallery[item.dataset.design].push({ src: item.dataset.src, alt: item.dataset.alt, label: item.dataset.label });
    });
    const normalize = (value) => String(value || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
    const optionNames = (product.options || []).map((option) => typeof option === 'string' ? option : option.name);
    const variants = product.variants || [];
    const valuesAt = (index) => index < 0 ? [] : [...new Set(variants.map((variant) => variant.options?.[index]).filter(Boolean))];
    const findOptionIndex = (configuredName, aliases, expectedValues) => {
      const configured = normalize(configuredName);
      let index = optionNames.findIndex((name) => normalize(name) === configured);
      if (index < 0) index = optionNames.findIndex((name) => aliases.includes(normalize(name)));
      if (index >= 0) return index;
      let bestIndex = -1;
      let bestScore = 0;
      optionNames.forEach((name, optionIndex) => {
        const values = valuesAt(optionIndex).map(normalize);
        const score = expectedValues.filter((expected) => {
          const expectedValue = normalize(expected);
          return values.some((value) => value === expectedValue || (expectedValue.length > 1 && value.includes(expectedValue)) || value.split(' ').includes(expectedValue));
        }).length;
        if (score > bestScore) { bestScore = score; bestIndex = optionIndex; }
      });
      return bestScore ? bestIndex : -1;
    };
    const designIndex = findOptionIndex(root.dataset.designOption, ['design', 'color', 'colour', 'style', 'pattern'], ['Strawberry', 'Frog', 'Flower']);
    const sizeIndex = findOptionIndex(root.dataset.sizeOption, ['size', 'pet size'], ['S', 'M', 'Small', 'Medium']);
    const maps = {
      design: { Strawberry: root.dataset.strawberryValue, Frog: root.dataset.frogValue, Flower: root.dataset.flowerValue },
      size: { S: root.dataset.sizeSValue, M: root.dataset.sizeMValue }
    };
    const valueMatches = (actual, configured, display, type) => {
      const actualValue = normalize(actual);
      const configuredValue = normalize(configured);
      const displayValue = normalize(display);
      if (!actualValue) return false;
      if (actualValue === configuredValue || actualValue === displayValue) return true;
      if (configuredValue.length > 1 && (actualValue.includes(configuredValue) || configuredValue.includes(actualValue))) return true;
      if (type === 'design' && displayValue.length > 2 && actualValue.includes(displayValue)) return true;
      const tokens = actualValue.split(' ');
      if (type === 'size' && display === 'S') return tokens.includes('s') || tokens.includes('small');
      if (type === 'size' && display === 'M') return tokens.includes('m') || tokens.includes('medium');
      return false;
    };
    const resolvedMaps = { design: {}, size: {} };
    Object.entries(maps).forEach(([type, displayMap]) => {
      const optionIndex = type === 'design' ? designIndex : sizeIndex;
      const actualValues = valuesAt(optionIndex);
      const displays = Object.keys(displayMap);
      displays.forEach((display, displayIndex) => {
        resolvedMaps[type][display] = actualValues.find((actual) => valueMatches(actual, displayMap[display], display, type))
          || (actualValues.length === displays.length ? actualValues[displayIndex] : displayMap[display]);
      });
    });
    const selectedVariantId = Number(root.dataset.selectedVariantId);
    const liquidVariant = selectedVariantId ? {
      id: selectedVariantId,
      available: root.dataset.initialAvailable === 'true',
      price: Number(root.dataset.initialPrice || 0),
      compare_at_price: Number(root.dataset.initialCompareAtPrice || 0),
      options: []
    } : null;
    const initialVariant = variants.find((variant) => Number(variant.id) === selectedVariantId) || variants.find((variant) => variant.available) || variants[0] || liquidVariant;
    const inferDisplay = (type, variant, optionIndex, fallback) => {
      if (!variant) return fallback;
      const candidates = optionIndex >= 0 ? [variant.options?.[optionIndex]] : (variant.options || []);
      return Object.keys(maps[type]).find((display) => candidates.some((actual) => normalize(actual) === normalize(resolvedMaps[type][display]) || valueMatches(actual, maps[type][display], display, type))) || fallback;
    };
    const state = { bundle: 'single', one: { design: inferDisplay('design', initialVariant, designIndex, 'Strawberry'), size: inferDisplay('size', initialVariant, sizeIndex, 'S') }, two: { design: 'Frog', size: 'S' } };
    const form = root.querySelector('[data-product-form]');
    const idInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const status = root.querySelector('[data-form-status]');
    const discount = Number(root.dataset.duoDiscount || 0);

    function resolveVariant(selection) {
      return variants.find((variant) => {
        if (designIndex >= 0 && sizeIndex >= 0 && designIndex !== sizeIndex) {
          if (normalize(variant.options?.[designIndex]) !== normalize(resolvedMaps.design[selection.design])) return false;
          if (normalize(variant.options?.[sizeIndex]) !== normalize(resolvedMaps.size[selection.size])) return false;
          return true;
        }
        const candidates = variant.options || [];
        const designMatch = candidates.some((actual) => valueMatches(actual, maps.design[selection.design], selection.design, 'design'));
        const sizeMatch = candidates.some((actual) => valueMatches(actual, maps.size[selection.size], selection.size, 'size'));
        return designMatch && sizeMatch;
      }) || null;
    }

    function showGallery(design, index = 0) {
      const items = gallery[design] || [];
      const item = items[index];
      if (!item) return;
      const main = root.querySelector('[data-main-image]');
      if (main) {
        main.style.opacity = '.2';
        window.setTimeout(() => { main.src = item.src; main.alt = item.alt; main.style.opacity = '1'; }, 80);
      }
      const badge = root.querySelector('[data-gallery-badge]');
      if (badge) badge.textContent = `${design} · ${item.label}`;
      const thumbs = root.querySelector('[data-gallery-thumbs]');
      if (thumbs) {
        thumbs.replaceChildren(...items.map((image, itemIndex) => {
          const button = document.createElement('button');
          const thumbnail = document.createElement('img');
          button.type = 'button';
          button.className = 'thumb';
          button.setAttribute('aria-current', String(itemIndex === index));
          button.setAttribute('aria-label', `Show ${design} ${image.label} photo`);
          thumbnail.src = image.src;
          thumbnail.alt = '';
          thumbnail.loading = 'lazy';
          button.append(thumbnail);
          button.addEventListener('click', () => showGallery(design, itemIndex));
          return button;
        }));
      }
    }

    function totals(first, second) {
      if (!first) return { final: 0, before: 0 };
      if (state.bundle === 'single') return { final: first.price, before: first.compare_at_price > first.price ? first.compare_at_price : 0 };
      if (!second) return { final: 0, before: 0 };
      const regular = Number(first.price) + Number(second.price);
      const final = discount ? Math.round(regular * (100 - discount) / 100) : regular;
      const compare = Number(first.compare_at_price || first.price) + Number(second.compare_at_price || second.price);
      return { final, before: compare > final ? compare : 0 };
    }

    function render() {
      const first = resolveVariant(state.one);
      const second = resolveVariant(state.two);
      const priceVariant = first || initialVariant;
      const total = totals(priceVariant, second);
      const available = Boolean(first && first.available && (state.bundle === 'single' || (second && second.available)));
      const price = root.querySelector('[data-price]');
      const before = root.querySelector('[data-price-before]');
      const saving = root.querySelector('[data-saving]');
      const hatTwo = root.querySelector('[data-hat-two]');
      if (price) price.textContent = total.final ? money(total.final) : (initialVariant ? money(initialVariant.price) : '');
      if (before) { before.textContent = total.before ? money(total.before) : ''; before.dataset.visible = String(Boolean(total.before)); }
      if (saving) saving.dataset.visible = String(state.bundle === 'duo' && discount > 0);
      if (hatTwo) hatTwo.dataset.visible = String(state.bundle === 'duo');
      if (idInput) idInput.value = first ? first.id : '';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? `${state.bundle === 'duo' ? 'Add duo to cart' : 'Add to cart'} · ${money(total.final)}` : (first || second ? 'Sold out' : 'Unavailable');
      }
      const stickyName = root.querySelector('[data-sticky-name]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickyThumb = root.querySelector('[data-sticky-thumb]');
      if (stickyName) stickyName.textContent = state.bundle === 'duo' ? `${state.one.design} + ${state.two.design} duo` : `${state.one.design} · Size ${state.one.size}`;
      if (stickyPrice) stickyPrice.textContent = total.final ? money(total.final) : '';
      if (stickyThumb && gallery[state.one.design]) stickyThumb.src = gallery[state.one.design][0].src;
    }

    all('[data-options="design"]', root).forEach((group) => all('[data-design]', group).forEach((button) => button.addEventListener('click', () => {
      const slot = group.dataset.slot;
      state[slot].design = button.dataset.design;
      all('[data-design]', group).forEach((option) => option.setAttribute('aria-pressed', String(option === button)));
      showGallery(state[slot].design);
      render();
    })));
    all('[data-options="size"]', root).forEach((group) => all('[data-size]', group).forEach((button) => button.addEventListener('click', () => {
      const slot = group.dataset.slot;
      state[slot].size = button.dataset.size;
      all('[data-size]', group).forEach((option) => option.setAttribute('aria-pressed', String(option === button)));
      render();
    })));
    all('[data-bundle]', root).forEach((button) => button.addEventListener('click', () => {
      state.bundle = button.dataset.bundle;
      all('[data-bundle]', root).forEach((option) => option.setAttribute('aria-pressed', String(option === button)));
      render();
    }));

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const first = resolveVariant(state.one);
      const second = resolveVariant(state.two);
      const items = state.bundle === 'duo' ? [first, second] : [first];
      if (items.some((variant) => !variant || !variant.available)) return render();
      addButton.disabled = true;
      if (status) status.textContent = '';
      try {
        const response = await fetch(config.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items.map((variant) => ({ id: variant.id, quantity: 1 })) }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this selection.');
        const cartResponse = await fetch(config.cartJsonUrl, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        all('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        const toast = root.querySelector('[data-toast]');
        if (toast) {
          toast.textContent = state.bundle === 'duo' ? 'Two hats added to your bag.' : `${state.one.design} hat added to your bag.`;
          toast.dataset.visible = 'true';
          window.clearTimeout(root.toastTimer);
          root.toastTimer = window.setTimeout(() => { toast.dataset.visible = 'false'; }, 2600);
        }
      } catch (error) {
        if (status) status.textContent = error.message;
      } finally { render(); }
    });

    root.querySelector('[data-shop-now]')?.addEventListener('click', () => root.scrollIntoView({ behavior: 'smooth' }));
    const sticky = root.querySelector('[data-sticky-shop]');
    const observed = document.querySelector('.hero') || addButton;
    if (sticky && observed && 'IntersectionObserver' in window) new IntersectionObserver((entries) => { sticky.dataset.visible = String(!entries[0].isIntersecting); }, { threshold: .08 }).observe(observed);
    all('[data-options="design"][data-slot="one"] [data-design]', root).forEach((option) => option.setAttribute('aria-pressed', String(option.dataset.design === state.one.design)));
    all('[data-options="size"][data-slot="one"] [data-size]', root).forEach((option) => option.setAttribute('aria-pressed', String(option.dataset.size === state.one.size)));
    showGallery(state.one.design);
    render();
  }

  function init(scope = document) {
    initMenu(scope);
    initAccordions(scope);
    all('[data-whimipaw-product]', scope).forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
